import { ActionIcon, Group, Menu } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
import { useLocalStorage } from "@mantine/hooks";

import type { CompanyCredentialsType } from "../../types";
import { generateRandomName } from "../../utils";
import { COMPANY_TOKEN_CREDENTIALS_KEY } from "../../config";

type SelectorMenuProps = {
  toggleUserDrawer: VoidFunction;
  toggleCompanyDrawer: VoidFunction;
};

export const SelectorMenu = ({
  toggleUserDrawer,
  toggleCompanyDrawer,
}: SelectorMenuProps) => {
  const [companyCredentials] = useLocalStorage<CompanyCredentialsType>({
    key: COMPANY_TOKEN_CREDENTIALS_KEY,
  });

  const usersLabel = companyCredentials?.user_id
    ? generateRandomName(
        companyCredentials.user_id,
        "user_id",
        companyCredentials?.company_id,
      )
    : "Select User";
  const companyLabel = companyCredentials?.company_id
    ? generateRandomName(
        companyCredentials.company_id,
        "company_id",
        companyCredentials?.company_id,
      )
    : "Select Company";

  const menuItemsConfig = [
    { handler: toggleCompanyDrawer, text: companyLabel, id: "company" },
    { handler: toggleUserDrawer, text: usersLabel, id: "user" },
  ];

  return (
    <Group hiddenFrom="sm">
      <Menu position="bottom-end" withinPortal>
        <Menu.Target>
          <ActionIcon
            variant="light"
            size="lg"
            aria-label="More actions"
            radius="md"
          >
            <IconDotsVertical size={18} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          {menuItemsConfig.map(({ text, handler, id }) => (
            <Menu.Item key={id} onClick={handler}>
              {text}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};
